import {useEffect, useState} from "react";

import {IOption} from "@pg-design/select-module";
import {IInteractiveRegion} from "@pg-rp/interactive-regions-map";

interface IProps {
    initialFormValue: IOption<number>[];
    formValue: IOption<number>[];
    handleFormUpdate: (locations: IOption<number>[]) => void;
}

export const useHomeMatchRegionSelection = (props: IProps) => {
    const normalizedFormValue = props.formValue.map((option) => ({
        value: option.value,
        label: option.label
    })) as IOption<number>[];

    const [confirmedValue, setConfirmedValue] = useState<IOption<number>[]>(normalizedFormValue);
    const [temporaryValue, setTemporaryValue] = useState<IOption<number>[]>(normalizedFormValue);
    const [isEditingFromMap, setIsEditingFromMap] = useState(false);

    useEffect(() => {
        setConfirmedValue(props.initialFormValue);
    }, []);

    useEffect(() => {
        setTemporaryValue(props.formValue);
    }, [
        props.formValue
            .map((r) => r.value)
            .sort()
            .join(",")
    ]);

    useEffect(() => {
        if (!isEditingFromMap) {
            const currentFormValue = props.formValue.map((option) => ({
                value: option.value,
                label: option.label
            })) as IOption<number>[];
            setTemporaryValue(currentFormValue);
        }
    }, [props.formValue, isEditingFromMap]);

    const handleUpdateRegionsByLocationPreview = (selectedRegions: IInteractiveRegion[], _parentRegion: {id: number; name: string; slug: string} | null) => {
        const regions = selectedRegions.map((region) => ({value: region.id, label: region.short_name}));

        // When user has selected multiple individual regions (not a whole city),
        // we need to sync map selections directly with the form to ensure consistency
        // between map and form selections for granular region management
        if (props.formValue.length > 1) {
            setTemporaryValue(regions || []);
            props.handleFormUpdate(regions || []);
        } else {
            setTemporaryValue(regions || []);
            setIsEditingFromMap(true);
        }
    };

    const handleApply = () => {
        props.handleFormUpdate(temporaryValue);
        setConfirmedValue(temporaryValue);
        setIsEditingFromMap(false);
    };

    const handleCancel = () => {
        props.handleFormUpdate(confirmedValue);
        setTemporaryValue(confirmedValue);
        setIsEditingFromMap(false);
    };

    const resetTemporarySelection = () => {
        setTemporaryValue(confirmedValue);
        setIsEditingFromMap(false);
    };

    return {
        handleUpdateRegionsByLocationPreview,
        handleApply,
        handleCancel,
        resetTemporarySelection,
        temporaryValue,
        confirmedValue,
        isEditingFromMap
    };
};
import {useEffect, useState} from "react";

import {IOption} from "@pg-design/select-module";
import {IInteractiveRegion} from "@pg-rp/interactive-regions-map";

interface IProps {
    initialFormValue: IOption<number>[];
    formValue: IOption<number>[];
    handleFormUpdate: (locations: IOption<number>[]) => void;
}

export const useHomeMatchRegionSelection = (props: IProps) => {
    const normalizedFormValue = props.formValue.map((option) => ({
        value: option.value,
        label: option.label
    })) as IOption<number>[];

    const [confirmedValue, setConfirmedValue] = useState<IOption<number>[]>(normalizedFormValue);
    const [temporaryValue, setTemporaryValue] = useState<IOption<number>[]>(normalizedFormValue);
    const [isEditingFromMap, setIsEditingFromMap] = useState(false);

    useEffect(() => {
        setConfirmedValue(props.initialFormValue);
    }, []);

    useEffect(() => {
        setTemporaryValue(props.formValue);
    }, [
        props.formValue
            .map((r) => r.value)
            .sort()
            .join(",")
    ]);

    useEffect(() => {
        if (!isEditingFromMap) {
            const currentFormValue = props.formValue.map((option) => ({
                value: option.value,
                label: option.label
            })) as IOption<number>[];
            setTemporaryValue(currentFormValue);
        }
    }, [props.formValue, isEditingFromMap]);

    const handleUpdateRegionsByLocationPreview = (selectedRegions: IInteractiveRegion[], _parentRegion: {id: number; name: string; slug: string} | null) => {
        const regions = selectedRegions.map((region) => ({value: region.id, label: region.short_name}));

        // When user has selected multiple individual regions (not a whole city),
        // we need to sync map selections directly with the form to ensure consistency
        // between map and form selections for granular region management
        if (props.formValue.length > 1) {
            setTemporaryValue(regions || []);
            props.handleFormUpdate(regions || []);
        } else {
            setTemporaryValue(regions || []);
            setIsEditingFromMap(true);
        }
    };

    const handleApply = () => {
        props.handleFormUpdate(temporaryValue);
        setConfirmedValue(temporaryValue);
        setIsEditingFromMap(false);
    };

    const handleCancel = () => {
        props.handleFormUpdate(confirmedValue);
        setTemporaryValue(confirmedValue);
        setIsEditingFromMap(false);
    };

    const resetTemporarySelection = () => {
        setTemporaryValue(confirmedValue);
        setIsEditingFromMap(false);
    };

    return {
        handleUpdateRegionsByLocationPreview,
        handleApply,
        handleCancel,
        resetTemporarySelection,
        temporaryValue,
        confirmedValue,
        isEditingFromMap
    };
};
